import { createSelector } from 'reselect';

const currencies = (state) => state.currency.list;

export const getCurrencies = createSelector(
    currencies,
    (currencies = []) => {
        return currencies.filter((item) => {
            return item.supported !== false;
        });
    }
);
